import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { ActionType, IAction, IMessage } from '@core';

@Component({
    selector: 'message-display',
    templateUrl: './message-display.component.html',
    styleUrls: ['./message-display.component.scss'],
    standalone: false
})
export class MessageDisplayComponent {
	private _message: IMessage;
	@Input()
	set message(value: IMessage) {
		this._message = value;
		if (value?.content) {
			this.sanitizedMessage = value.content; // Angular sanitize automatiquement [innerHTML]
		}
	}

	get message(): IMessage {
		return this._message;
	}

	@Input() displayOnPage: boolean = false;
	@Input() displayCloseBtn: boolean = true;

	@Output() action: EventEmitter<IAction> = new EventEmitter();

	sanitizedMessage: string;

	get btnCloseLabel(): string {
		if (this.message.blockConnection) {
			return 'Actions.Logout';
		} else if (this.message.displayOnce) {
			return 'Actions.Understand';
		} else {
			return 'Actions.Close';
		}
	}

	constructor(private sanitizer: DomSanitizer) {}

	close() {
		this.action.next({
			type: ActionType.Close,
			value: this.message
		});
	}
}
